// extracted by mini-css-extract-plugin
export default {"Prato":"Prato_Prato__F1YY9","Tag":"Prato_Tag__VBuI6","Container":"Prato_Container__-I+14","EfeitoTorcao":"Prato_EfeitoTorcao__FVsS3","Conteudo":"Prato_Conteudo__pV4xP"};